import { useQuery } from "@tanstack/react-query";
import { DefaultFilter } from "../../@types/filter";
import { apisiseci } from "../api";
import { useDefaultSearchParams } from "../../hooks/useSearchParams";
import { AxiosError } from "axios";
import { Unity } from "../../@types/unity";
import { Paginated } from "../../@types/paginated";

type Props = DefaultFilter & {
  ativo?: boolean;
};

export function useUnityList(params?: Props) {
  const token = localStorage.getItem("gov_access_token_sso");
  const defaultParams = useDefaultSearchParams();
  params = { ...defaultParams, ...params };

  return useQuery<Paginated<Unity>, AxiosError<{ detail: string }>>({
    enabled: !!token,
    queryKey: ['unity', 'list', params],
    queryFn: async () => {
      const response = await apisiseci.get<Paginated<Unity>>(
        "/cms/unidades/",
        { headers: { Authorization: `Bearer ${token}` }, params }
      );
      return response.data;
    },
  });
}
